import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  align-items: center;
`

export const LeftSide = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
`

export const RightSide = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;
`
